import { lazy } from 'react';

// ----------------------------------------------------------------------

const EmployeeDetailsPage = lazy(() => import('../pages/EmployeeDetails.page'));
const EmployeesPage = lazy(() => import('../pages/Employees.page'));
const AddEmployeePage = lazy(() => import('../pages/AddEmployee.page'));
const EditEmployeePage = lazy(() => import('../pages/EditEmployee.page'));
const AddTrainerPage = lazy(() => import('../pages/trainer/AddTrainer.page'));
const TrainerDetails = lazy(() => import('../pages/trainer/TrainerDetails.page'));
const EditTrainerPage = lazy(() => import('../pages/trainer/EditTrainer.page'));

// ----------------------------------------------------------------------

const EmployeeRoutes = [
    {
        path: '/employees',
        children: [
            { path: 'employe', element: <EmployeesPage />, layout: 'default', isAuthReq: true },
            { path: 'add-employee', element: <AddEmployeePage />, layout: 'default', isAuthReq: true },
            { path: 'employee/:id', element: <EmployeeDetailsPage />, layout: 'default', isAuthReq: true },
            { path: 'employee/:id/edit', element: <EditEmployeePage />, layout: 'default', isAuthReq: true },
            { path: 'add-trainer', element: <AddTrainerPage />, layout: 'default', isAuthReq: true },
            { path: 'trainer/:id/edit', element: <EditTrainerPage />, layout: 'default', isAuthReq: true },
            { path: 'trainer/:id', element: <TrainerDetails />, layout: 'default', isAuthReq: true },
        ],
    },

];

export { EmployeeRoutes };
